import { GroupType } from '@/views/other-pages/sample-company/config'

export default {
  computed: {
    groupType() {
      return this.$route.query.groupType
    },
    isPhone() {
      return GroupType.Phone.toString() === this.groupType
    },
    isEmail() {
      return GroupType.Email.toString() === this.groupType
    },
    isAddress() {
      return GroupType.Address.toString() === this.groupType
    }
  }
}
